import { CancelAsync } from './../../app/models/cancelAsync';
import { Component, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import {
  PageLoaderService,
  AppInitService,
  StatsService,
  StudentService,
  StorageService,
  NetworkStatusService,
  NavigationService,
} from '@app/services';

import { Student } from '@app/models';

import { ModalController, Platform } from '@ionic/angular';
import { ModalIframeComponent } from '@app/modals';

import { Router } from '@angular/router';

import { UtilsService } from '@commons/services';

import { EasyDebugDecorator } from '../../app/decorators/easy-debug.decorator';

@EasyDebugDecorator
@Component({
  selector: 'disconnected-page',
  templateUrl: 'disconnected.page.html',
  styleUrls: ['disconnected.page.scss'],
})
export class DisconnectedPage extends CancelAsync {
  pageTitle = 'Disconnected';
  activeLink = 'code';

  storageLocked = false;

  student: Student;
  userLifeCycle: any;

  iconPath = './uikit-assets/icons/orion-svg-sprite.svg#';

  isDesktop = window.innerWidth > 767 ? true : false;

  stepChangeSub: any;
  pageLoaderSteps = [
    'init0',
    'init1',
    'init2',
    'init3',
    'init4',
    'init5',
    'initPage',
  ];
  hasMadeInit = false;

  @HostListener('window:resize', ['$event']) onResize(event) {
    this.isDesktop = window.innerWidth > 767 ? true : false;
  }

  constructor(
    public pageLoaderService: PageLoaderService,
    private activatedRoute: ActivatedRoute,
    private appInitService: AppInitService,
    private statsService: StatsService,
    public router: Router,
    private studentService: StudentService,
    private storageService: StorageService,
    private networkStatusService: NetworkStatusService,
    private navigationService: NavigationService,
    private modalController: ModalController,
    private utilsService: UtilsService,
    private platform: Platform
  ) {
    super({ cancel: false, subscription: null });

    if (!this.appInitService.done) {
      this.navigationService.timestamp = Date.now();
      this.navigationService.lastLink = this.router.url.substr(1);
      this.hasMadeInit = true;
    } else {
      this.hasMadeInit = false;
    }

    this.userLifeCycle = this.studentService.getUserLifeCycle(this.student); // if student not ready return guest
    if (this.appInitService.done) {
      this.pageLoaderSteps = ['initApp', 'initPage'];
      this.pageLoaderService.setSteps(
        this.pageLoaderSteps.indexOf('initApp') + 1,
        this.pageLoaderSteps.length
      );
    }
    this.stepChangeSub = this.appInitService.onStepChange().subscribe(state => {
      if (state?.init && state?.stepDone) {
        this.pageLoaderService.setSteps(
          state.init + 1,
          this.pageLoaderSteps.length
        );
      }
      if (state?.initDone) {
        this.initPage();
      }
    });
  }

  ionViewWillLeave() {
    // this.cancel = true;
    if (!!this.subscription) {
      this.subscription.unsubscribe();
    }
    if (!!this.stepChangeSub) {
      this.stepChangeSub.unsubscribe();
    }
  }

  async initPage() {
    this.storageLocked = false;
    if (this.platform.is('cordova')) {
      this.storageLocked = !(await this.storageService.checkEnougthSpace());
    }

    this.student = await this.studentService.getProfil();
    this.userLifeCycle = this.studentService.getUserLifeCycle(this.student);
    this.pageLoaderService.setSteps(
      this.pageLoaderSteps.indexOf('initPage') + 1,
      this.pageLoaderSteps.length
    );
    setTimeout(() => {
      this.pageLoaderService.stepsDone();
    }, 300);

    // PAGE LOAD EVENT
    if (
      !!this.navigationService.timestamp &&
      !!this.navigationService.lastLink
    ) {
      const statObj = {
        page: this.navigationService.lastLink,
        loadTime: Date.now() - this.navigationService.timestamp,
        withInit: this.hasMadeInit,
      };
      if (this.statsService.isDebug) {
        console.log(statObj);
      }
      this.statsService.send({ name: 'page:view', payload: statObj });
    }
  }

  reloadLink() {
    this.navigationService.reloadLink();
  }

  async openModalIframe(url: any, type?: string, noClose = true) {
    if (!type) {
      type = 'iframe';
    }
    let modal;
    if (noClose) {
      modal = await this.modalController.create({
        component: ModalIframeComponent,
        backdropDismiss: false,
        cssClass: 'custom-modal-iframe',
        componentProps: {
          type: type,
          url: url,
        },
      });
    } else {
      modal = await this.modalController.create({
        component: ModalIframeComponent,
        cssClass: 'custom-modal-iframe',
        componentProps: {
          type: type,
          url: url,
        },
      });
    }
    return await modal.present();
  }

  closeModals() {
    const modals = document.getElementsByTagName('ion-modal');
    while (modals.length > 0) {
      modals[0].parentNode.removeChild(modals[0]);
    }
  }

  async openLink(link, options?) {
    const callbackUrl = await this.navigationService.open(link, options);
    if (!!callbackUrl && callbackUrl !== '') {
      this.openModalIframe(callbackUrl);
    }
  }
}
